<div class="tabs__nav-wrapper">
  <div class="tabs__nav" #tabsnav>
    @for (tab of tabs(); track $index) {
      <div class="tabs__nav-item" (click)="activeTabIndex.set($index)" [class.active]="activeTabIndex() === $index">
        <div class="tabs__nav-caption">
          <div class="tabs__nav-title">{{ tab.title }}</div>
          <div class="tabs__nav-subtitle">{{ tab.subtitle }}</div>
        </div>
      </div>
    }
    <div class="tabs__controls">
      <div class="tabs__control" (click)="moveLeft()">
        <svg-icon src="assets/images/icons/arrow-small-left.svg"></svg-icon>
      </div>
      <div class="tabs__control" (click)="moveRight()">
        <svg-icon src="assets/images/icons/arrow-small-right.svg"></svg-icon>
      </div>
    </div>
  </div>
</div>
